<main role="main" id="content" tabindex="-1" class="instant-estimate-page">
  @if (loadError()) {
    <div class="alert alert-danger" role="alert">{{ loadError() }}</div>
  } @else if (config(); as cfg) {
    <app-instant-estimate
      [config]="cfg"
      [schoolId]="schoolIdSignal()"
      displayMode="full"
      [accentColor]="accentColor()"
      [panelColor]="panelColor()"
      [showSchoolEyebrow]="showSchoolEyebrow()"
    />
  }
</main>
